import React, { useState } from 'react';
import classes from "./CategoryPage.module.css";
import styles from './SubscriptionPage.module.css';
import CategoriesSection from '../components/CategoriesSection';
import Lottie from 'lottie-react';
import stars from "../animations/stars3.json";
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from "react-router";
import axios from 'axios';
import {sendOtp} from "../http/http"
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";





export default function SubscriptionPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const extId = searchParams.get("ext_id") || uuidv4();
    setSearchParams({ ext_id: extId });

    if (!msisdn) {
      toast.error("Please enter your mobile number");
      return;
    }



    try {
      setLoading(true);
      const response = await sendOtp(msisdn);
      console.log("Response:", response);

      console.log("resmsg",response?.data?.msg)
      console.log("success",response?.data?.success)

      
      if (response?.data?.is_subscribed && response?.data?.success) {
        console.log("-----------------")
        if(response?.data?.success){
       toast.success(response?.data?.msg);
        navigate(`/home`);
        }
       
      }

      
      else if (!response?.data?.is_subscribed && response?.data?.success) {
        if(response?.data?.success){
          toast.success(response?.data?.msg);
        console.log("msg",response?.msg)
        navigate(`/otp?ext_id=${extId}`,{
          state:{
            msisdn:msisdn
          }
        });
        }
       
      }

      else {
        toast.error(response?.data?.msg);
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while sending OTP!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Lottie
          animationData={stars}
          loop={true}
          autoplay={true}
          initialSegment={[0, 100]}
          className={classes.background_animation}
        />
        <div className={styles.card}>
          <h1 className={styles.title}>Subscribe to KidsLab</h1>
          <p className={styles.desc}>Get fun educational content delivered via Mobily subscription.</p>

          <form onSubmit={handleSubscribe} className={styles.form}>
            <label className={styles.label}>Mobile Number</label>
            <input
              className={styles.input}
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              placeholder="+91XXXXXXXXXXX"
              inputMode="tel"
            />
            <button
              className={styles.button}
              type="submit"
              disabled={loading}
            >
              {loading ? "Please wait..." : "Subscribe Now"}
            </button>
          </form>
        </div>
      </div>
      <CategoriesSection />
    </>
  );
}
